/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback, useRef } from 'react'
import clsx from 'clsx';
import customStyles from "../../../../../assets/styles/customStyles";
import { useDispatch, useSelector } from "react-redux";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import actions from "../../redux/actions";
import crudActions from "../../../../CRUD/redux/actions";
import { NavLink } from "react-router-dom";
import { CityTable } from "./CityTable";
import { Col, Image, Row, Space } from "antd";
import { Button, TextField, Box, Autocomplete } from "@mui/material";
import Down from "../../../../Shared/components/Icons/Down";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import ImportIcon from "../../../../../assets/images/icon_actions/Import.svg";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import MainHeader from "../../../../Shared/components/Header";
import { toast } from 'react-toastify';
import usePrevious from "../../../../Shared/components/Previous";
import { emptyValidation } from "../../../../../helpers/validation";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import { ImportExport } from '../../../../Shared/components/ImportExport';
import { checkCRUDPermission, checkComponentPermission } from '../../../../../helpers/utilities';
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";

const City = (props) => {
    const { countryDetails, stateDetails, cityDetails, cityLoader } = useSelector(state => state.addressReducer);
    const { createDetails, createError, createLoader, getList, getData } = useSelector(state => state.crudReducer);
    const [visible, setVisible] = useState(false);
    const [cityName, setCityName] = useState('');
    const [stateId, setStateId] = useState('');
    const [countryId, setCountryId] = useState('');
    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);

    const [errorCityName, setErrorCityName] = useState(false);
    const [errorStateId, setErrorStateId] = useState(false);
    const [errorCountryId, setErrorCountryId] = useState(false);

    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const prevSearch = usePrevious(search);
    const [skip, setSkip] = useState(0);
    const limit = 25;
    const timeoutRef = useRef(null);
    const dispatch = useDispatch();
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");
    const [filterStateId, setFilterStateId] = useState('');

    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const type = 'import';
    const [importVisible, setImportVisible] = useState(false);

    const { roleManagement } = useSelector(state => state.authReducer);
    const { moduleType } = props;
    const searchInput = useRef(null);

    const onExport = () => {
        loadImportExportData('City');
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        dispatch({
            type: actions.CITY_DETAILS_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            url: 'city',
            filter: {
                order: sortBy + ' ' + sortOrder,
            }
        });
    }

    const handleOpen = () => {
        setVisible(true);
    };

    const handleClose = () => {
        setVisible(false);
        emptyState();
        emptyStateInput();
    };

    useEffect(() => {
        if ((prevSearch !== undefined && search && search?.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(filterStateId, sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(filterStateId, sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);

    useEffect(() => {
        if (roleManagement !== '') {
            // if (checkViewPermission('City', history, 'Younote Admin')) {
            loadTasks();
            // }
        }
        return () => {
            dispatch({
                type: actions.CLEAR_ADDRESS_DETAILS_START,
            });
        };
    }, [roleManagement]);

    const prevGetData = usePrevious(getData); useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData?.length > 0) {
                    setLoadMore(true);
                    if (getData?.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const dispatchFilter = (stateId, sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["and"]: [] };

        if (search !== '') {
            filter['and'].push({ name: { like: '%' + search.trim() + '%' } })
        }

        if (stateId !== '') {
            filter['and'].push({ stateId: stateId });
        }


        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'city',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            }
        });

    }

    const emptyState = () => {
        setErrorCityName(false);
        setErrorStateId(false);
        setErrorCountryId(false);
    }

    const emptyStateInput = () => {
        setCityName('');
        setStateId('');
        setCountryId('');
    }

    const loadTasks = useCallback(() => {
        dispatch({
            type: actions.COUNTRY_DETAILS_START, url: 'country', filter: {
                order: 'id desc'
            }
        });
        dispatch({
            type: actions.STATE_DETAILS_START, url: 'state', filter: {
                order: 'id desc'
            }
        });
        dispatchFilter(filterStateId, sortBy, sortOrder);
    });

    const createCity = (e) => {
        e.preventDefault();
        let emptyCityName = emptyValidation('City Name', cityName);
        let emptyStateId = emptyValidation('State', stateId, 'dropDown');
        emptyState();
        if (emptyCityName.isValid && emptyStateId.isValid) {
            dispatch({
                type: crudActions.CREATE_DETAILS_START,
                url: 'city',
                title: "City",
                details: {
                    name: cityName,
                    stateId: stateId,
                    countryId: countryId
                }
            });
        } else {
            if (emptyCityName.errors !== '') {
                setErrorCityName(emptyCityName.errors);
            } if (emptyStateId.errors !== '') {
                setErrorStateId(emptyStateId.errors);
            }
        }
    }

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            dispatchFilter(filterStateId, sortBy, sortOrder);
            setVisible(false);
            toast.dismiss();
            toast(createDetails);
            emptyStateInput();
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let error = createError.error.message;
            setErrorCityName(error);
        }
    }, [createDetails, createError]);


    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }



    const changeState = (value) => {
        setStateId(value);
        let a = stateDetails && stateDetails.filter(function (el) { return el.id === value });
        if (a && a?.length !== 0) {
            setCountryId(a[0].countryId);
        }
    }

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(filterStateId, sortBy, sortOrder);
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(filterStateId, sortBy, sortOrder, s);
    }

    const handleOpenImport = () => {
        setImportVisible(true);
    }

    const handleImportClose = () => {
        setImportVisible(false);
    }

    const handleChange = (e) => {
        if (e.target.value === '') {
            handleChangeState('')
        }
    }

    const handleChangeState = (value) => {
        setFilterStateId(value);
        dispatchFilter(value, sortBy, sortOrder);
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader {...props} img={SettingsImg}
                title={moduleType !== undefined ? moduleType : 'Younote Admin'}
                links={[{ 'label': moduleType !== undefined ? moduleType : 'Younote Admin', 'link': moduleType === 'Admin' ? '/admin' : '/younote-admin' },
                { 'label': 'Address Management', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'City'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('City', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search'
                                                type='search'
                                                value={search}
                                                className={classes.comInput}
                                                required
                                                variant={'standard'}
                                                onChange={(e) => setSearch(e.target.value)}
                                                fullWidth
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                            {
                                                search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                                    <Image
                                                        src={ClearIcon}
                                                        preview={false}
                                                    />
                                                </NavLink>
                                            }
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.removeUnderline, classes.vertiCalScrollOverFlowParent)}>
                                    <div className={classes.vertiCalScrollOverFlow}>
                                        <Space size={[20, 20]} direction="horizontal" align="center">
                                            <Autocomplete
                                                className={clsx(classes.customAutocomplete, classes.customAutocompleteBorder, classes.width200)}
                                                popupIcon={<Down />}
                                                fullWidth
                                                forcePopupIcon={"auto"}
                                                clearOnEscape
                                                onClose={() => {
                                                    searchInput.current.blur();
                                                }}
                                                disableClearable
                                                getOptionLabel={(option) => option.name ? option.name : ""}
                                                options={stateDetails ? stateDetails : []}
                                                classes={{ paper: classes.dropdownStyle }}
                                                value={stateDetails && customObject(stateDetails, filterStateId) ? customObject(stateDetails, filterStateId) : []}
                                                onChange={(event, newValue) => {
                                                    if (typeof newValue === 'object' && newValue !== null) {
                                                        handleChangeState(newValue.id) // help to set the value
                                                    } else {
                                                        handleChangeState('') // help to reset the value
                                                    }
                                                }}
                                                renderInput={(params) => (
                                                    <TextField autoComplete='one-time-code'
                                                        inputRef={searchInput}
                                                        name={'stateId'}
                                                        onChange={(e) => handleChange(e)}
                                                        {...params}
                                                        label='All State'
                                                        variant="standard"
                                                    />
                                                )}
                                            />
                                            {
                                                roleManagement !== '' && checkComponentPermission('City', 'Action', 'Export') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => onExport()}
                                                    className={clsx(classes.customLink)}
                                                >
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('City', 'Action', 'Import') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => handleOpenImport()}
                                                    className={clsx(classes.customLink)}
                                                >
                                                    <Image
                                                        src={ImportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Import</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && (checkCRUDPermission('City', 'create', 'Younote Admin') || checkCRUDPermission('City', 'create', 'Admin')) &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => handleOpen()}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Add</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('City', 'Action', 'Filter') &&
                                                <></>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <CityTable
                                loadTasks={() => dispatchFilter(filterStateId, sortBy, sortOrder)}
                                countryDetails={countryDetails}
                                moduleType={moduleType}
                                stateDetails={stateDetails}
                                cityDetails={getList}
                                loadMore={loadMore}
                                loadMoreContent={loadMoreContent}
                                loadMoreTask={() => loadMoreTask()}
                                sortOrder={sortOrder} sortBy={sortBy}
                                customObject={(details, id) => customObject(details, id)}
                                roleManagement={roleManagement}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)} />
                        </>
                    }
                />
                <PrimaryDrawer
                    anchor={'right'}
                    open={visible}
                    variant={'temporary'}
                    handleClose={() => handleClose()}
                    title={'Add City'}
                    width={"360px"}
                    className={clsx(classes.closeBackGround, classes.width100P)}
                    component={
                        <Box
                            className={clsx(classes.customForm, classes.removeUnderline)}
                            component="form"
                            autoComplete="off"
                            onSubmit={(e) => createCity(e)}
                        >
                            <div className={classes.customFormFlex}>
                                <TextField autoComplete='one-time-code'
                                    label={["City Name ", <span key={"City Name"} className={classes.colorRedRequired}> *</span>]}
                                    variant={'standard'}
                                    error={errorCityName ? true : false}
                                    helperText={errorCityName}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onChange={(e) => setCityName(e.target.value)}
                                />
                                <AutoCompleteComponent
                                    name={["State ", <span key={"State"} className={classes.colorRedRequired}> *</span>]}
                                    heads={[{ 'key': 'name', 'name': 'State Name' },
                                    { 'key': 'country', 'name': 'Country Name', 'relation': 'name' }]}
                                    details={stateDetails}
                                    parentValue={customObject(stateDetails, stateId)}
                                    onChange={(data) => changeState(data.id)}
                                    position={'bottom'}
                                    customClasses={classes.margin20t}
                                    parentError={errorStateId}
                                />

                                <AutoCompleteComponent
                                    name={["Country"]}
                                    heads={[{ 'key': 'name', 'name': 'Country Name' }]}
                                    details={countryDetails}
                                    parentValue={customObject(countryDetails, countryId)}
                                    onChange={(data) => setCountryId(data.id)}
                                    position={'bottom'}
                                    parentError={errorCountryId}
                                    customClasses={classes.margin20t}
                                />
                            </div>
                            <div className={clsx(classes.btnParent)}>
                                <Button
                                    key="add"
                                    type='submit'
                                    color='primary'
                                    variant="contained"
                                    className={clsx(classes.modalBtn, { [classes.loading]: createLoader })}>
                                    Save
                                </Button>
                            </div>
                        </Box>
                    }
                />
                <ImportExport
                    handleClose={() => handleImportClose()}
                    visible={importVisible}
                    title={'City'}
                    type={type}
                    details={cityDetails}
                    loader={cityLoader}
                    loadImportExportData={(name, type, selected, extension) => loadImportExportData(name, type, selected, extension)}
                    loadTasks={() => { dispatchFilter(filterStateId, sortBy, sortOrder) }}
                />
            </div>
        </React.Fragment >
    )
}

export default City